export const options = [
  { value: 'NoAccess', label: 'No Access' },
  { value: 'Read', label: 'Read Access' },
  { value: 'Write', label: 'Write Access' },
  { value: 'Push', label: 'Push Access' },
  { value: 'Admin', label: 'Admin Access' },
];
